import FinFitView from "../Views/FinFitView.vue"
import IncomeKnowledge from "../Pages/IncomeKnowledgePage"
import UserQuestion from "../Pages/UserQuestion.vue"

const routes = [
    {
        path:'/finfit',
        component: FinFitView,
        children: [
            {
              path: 'question/:questionNumber',
              name: 'Quiz',
              component: UserQuestion,
              meta: {
                quizRequired: true
              }
            },
          {
            path: '/income_knowledge',
            name: 'QuizResults',
            component: IncomeKnowledge,
            meta: {
              quizRequired: true
            }
          }
        ]
    }
]

export default routes
